import angular from 'angular'
import forEach from 'lodash/forEach'

/**
 * ID Badge Controller
 */
class IdBadgeController {
  constructor($attrs, $element, $transclude, elementService) {
    'ngInject'
    this._elementService = elementService
    this._$attrs = $attrs
    this._$transclude = $transclude
    this._$element = $element
  }

  $onInit() {
    this.lazyLoadImage = this.lazyLoad === undefined ? true : this.lazyLoad
  }

  $onDestroy() {
    if (this.anchor) {
      this.anchor.remove()
    }
  }

  $postLink() {
    const VD_BASE_CLASS = 'vd-id-badge'
    const elementClasses = [VD_BASE_CLASS]
    const modifiers =
      this._elementService.getComponentAttrs(this._$attrs, 'modifier') || []

    this.hasDescription = this._$transclude.isSlotFilled('description')

    if (modifiers) {
      forEach(modifiers, modifier => {
        const hasInteractiveModifier = modifier.indexOf('interactive') > -1

        elementClasses.push(`${VD_BASE_CLASS}--${modifier}`)

        // Set the tabindex for interactive badges, if not set already
        if (
          angular.isUndefined(this._$attrs.tabindex) &&
          hasInteractiveModifier
        ) {
          this._$attrs.$set('tabindex', 0)
        }
      })
    }

    // If the ID badge has a hyperlink attribute, then wrap the entire
    // ID badge inside an anchor tag with its href set to the specified hyperlink.
    if (this.hyperlink) {
      const el = this._$element[0] // the badge
      this.anchor = document.createElement('a')
      this.anchor.setAttribute('href', this.hyperlink)
      this.anchor.classList.add('vd-id-badge--hyperlink')
      el.parentNode.insertBefore(this.anchor, el) // insert before badge
      this.anchor.appendChild(el) // move badge inside link
    }

    this._$attrs.$addClass(elementClasses)
  }

  /**
   * Get the background image for the avatar.
   *
   * @method getBackgroundImage
   *
   * @return {String|undefined} The background image string for the avatar or undefined if an image is not supplied.
   */
  getBackgroundImage() {
    return this.image ? `background-image: url(${this.image})` : undefined
  }
}

export default IdBadgeController
